import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
import "tippy.js/themes/light.css";
import isMobile from "../../helpers/isMobile";

export default function () {
  const triggers = document.querySelectorAll(".tooltip__trigger");

  triggers.forEach(trigger => {
    const tooltip = document.querySelector(trigger.getAttribute("data-tooltip"));

    if (trigger.classList.contains("clipboard-btn")) {
      tippy(trigger, {
        allowHTML: true,
        content: tooltip.innerHTML,
        trigger: 'click',
        theme: "light",
        placement: isMobile() ? "left" : "right"
      });
    } else {
      tippy(trigger, {
        allowHTML: true,
        content: tooltip.innerHTML,
        theme: "light",
        placement: isMobile() ? "left" : "right"
      });

    }
  });
}
